// 此页面是活动数据统计的路由钩子，用于上报统计数据的
import store from '@/store/index'
import Vue from 'vue'
import { getLoginInfo } from '@/utils/loginInfo'

const getParams = (to, path) => {
    if (Vue.$bridge.isStore()) { // 门店app内嵌-(目前只内嵌了秒杀页面)
        if (to.name !== 'seckill') return
        try {
            const {
                activity_id,
                // app_name,
                sstore_id,
                user_id,
                token
            } = store.state.appInfo.icarAppInfo
            // alert(JSON.stringify(store.state.appInfo.icarAppInfo))
            return {
                token: token,
                user_id: user_id ? Number(user_id) : 0, // 用户Id
                sstore_id: sstore_id, // 门店id
                channel: 3, // 访问渠道 (1 微养车 2 H5 , 3: 养车app)
                visit_type: 1, // 访问类型 (1普通进入 2分享链接 3扫二维码(预留))
                page_code: 'seckill',
                param_type: 'activity_id',
                param_value: activity_id
            }
        } catch (err) {
            alert(String(err))
        }
    } else {
        const {
            sstore_id = '',
            activity_id = '',
            topic_id = '',
            visitType = '',
        } = to.query
        const {
            user_id = ''
        } = getLoginInfo()
        const paramTypeArr = {
            'mergeSpread': 'topic_id', // 聚合推广
            'customDetail': 'topic_id', // 商家推广-自定义多店
            'regularCustomDetail': 'topic_id', // 商家推广-常规推广多店
            'seckill': 'activity_id', // 秒杀
            // '/marketingDetail': 'activity_id',  // 特价活动需要activity_id做统计，但是有些链接没带activity_id，估在具体页面做统计
            // '/specialActivity': 'activity_id', //
        }
        return {
            sstore_id: sstore_id, // 门店id
            user_id: user_id ? Number(user_id) : 0, // 用户id (0 为未登录)
            channel: 2, // 访问渠道 (1 微养车 2 H5)
            visit_type: visitType === 2 ? 2 : 1, // 访问类型 (1普通进入 2分享链接 3扫二维码(预留))
            page_code: to.name,
            param_type: paramTypeArr[to.name],
            param_value: activity_id || topic_id
        }
    }
}

export default (router) => {
    router.beforeEach((to, _, next) => {
        const routerPath = to.path
        // pecialActivity?topic_id=124&sstore_id=942&latitude=23.21251&longitude=113.33748
        // https://test-yc.carisok.com/#/marketingDetail?topic_id=124
        // 例子：
        /**
         *
        秒杀活动页（多店）：http://test-yc.carisok.com/#/seckill?sstore_id=&activity_id=305

        秒杀活动页（单店）：http://test-yc.carisok.com/#/seckill?sstore_id=11292&activity_id=305

        特价活动页（多店）：https://test-yc.carisok.com/#/marketingDetail?topic_id=124

        特价活动页（单店）：https://test-yc.carisok.com/#/specialActivity?sstore_id=11311&topic_id=124

        聚合推广（多店）：https://test-yc.carisok.com/#/mergeSpread?topic_id=222

        商家自定义推广-多店： http://test-yc.carisok.com/#/customDetail?topic_id=509&visit_type=2

         *
         *
         */
        const routers = [
            '/mergeSpread', // 聚合推广
            '/customDetail', // 商家自定义推广-多店
            // '/customSingularDetail', // 商家自定义推广-单店(暂不需要)
            '/regularCustomDetail', // 商家常规推广-多店
            // '/marketingDetail', // 特价活动需要activity_id做统计，但是有些链接没带activity_id(在详情接口返回)，故在具体页面做统计
            // '/specialActivity', // 特价活动需要activity_id做统计，但是有些链接没带activity_id(在详情接口返回)，故估在具体页面做统计
            '/seckill', // 秒杀(暂时不需要)(暂不需要)
        ]
        routers.forEach(path => {
            if (path === routerPath) {
                const { param_type } = getParams(to, path)
                if (param_type) store.dispatch('addVisitLog', getParams(to, path))
            }
        })
        next()
    })
}
